/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { DimensionType } from '../models/dimension-type';
import { IsoStandardDto } from '../models/iso-standard-dto';
import { IsoStandardDtoBaseResponse } from '../models/iso-standard-dto-base-response';
import { IsoStandardDtoListBaseResponse } from '../models/iso-standard-dto-list-base-response';
import { IsoStandardListDtoPagedResponseBaseResponse } from '../models/iso-standard-list-dto-paged-response-base-response';
import { OrderDirection } from '../models/order-direction';
import { PropertyFilter } from '../models/property-filter';
import { ToleranceClassDto } from '../models/tolerance-class-dto';
import { ToleranceClassDtoBaseResponse } from '../models/tolerance-class-dto-base-response';
import { ToleranceDto } from '../models/tolerance-dto';
import { ToleranceDtoBaseResponse } from '../models/tolerance-dto-base-response';

@Injectable({
  providedIn: 'root',
})
export class IsoStandardService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiIsoStandardPaginatedListGet
   */
  static readonly ApiIsoStandardPaginatedListGetPath = '/api/IsoStandard/paginated-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardPaginatedListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardPaginatedListGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<IsoStandardListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardPaginatedListGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardPaginatedListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardPaginatedListGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<IsoStandardListDtoPagedResponseBaseResponse> {

    return this.apiIsoStandardPaginatedListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardListDtoPagedResponseBaseResponse>) => r.body as IsoStandardListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardPaginatedListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardPaginatedListGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<IsoStandardListDtoPagedResponseBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardPaginatedListGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardListDtoPagedResponseBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardPaginatedListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardPaginatedListGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<IsoStandardListDtoPagedResponseBaseResponse> {

    return this.apiIsoStandardPaginatedListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardListDtoPagedResponseBaseResponse>) => r.body as IsoStandardListDtoPagedResponseBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardGetAllGet
   */
  static readonly ApiIsoStandardGetAllGetPath = '/api/IsoStandard/get-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardGetAllGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetAllGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<IsoStandardDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardGetAllGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardGetAllGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetAllGet$Plain(params?: {
  }): Observable<IsoStandardDtoListBaseResponse> {

    return this.apiIsoStandardGetAllGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoListBaseResponse>) => r.body as IsoStandardDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardGetAllGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetAllGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<IsoStandardDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardGetAllGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardGetAllGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetAllGet$Json(params?: {
  }): Observable<IsoStandardDtoListBaseResponse> {

    return this.apiIsoStandardGetAllGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoListBaseResponse>) => r.body as IsoStandardDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardGetAllByTypeGet
   */
  static readonly ApiIsoStandardGetAllByTypeGetPath = '/api/IsoStandard/get-all-by-type';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardGetAllByTypeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetAllByTypeGet$Plain$Response(params?: {

    /**
     * 1 &#x3D; Radii
     * 
     * 2 &#x3D; Linear
     * 
     * 3 &#x3D; Diameter
     * 
     * 4 &#x3D; SurfaceFinish
     * 
     * 5 &#x3D; Parallelism
     */
    type?: DimensionType;
  }): Observable<StrictHttpResponse<IsoStandardDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardGetAllByTypeGetPath, 'get');
    if (params) {
      rb.query('type', params.type, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardGetAllByTypeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetAllByTypeGet$Plain(params?: {

    /**
     * 1 &#x3D; Radii
     * 
     * 2 &#x3D; Linear
     * 
     * 3 &#x3D; Diameter
     * 
     * 4 &#x3D; SurfaceFinish
     * 
     * 5 &#x3D; Parallelism
     */
    type?: DimensionType;
  }): Observable<IsoStandardDtoListBaseResponse> {

    return this.apiIsoStandardGetAllByTypeGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoListBaseResponse>) => r.body as IsoStandardDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardGetAllByTypeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetAllByTypeGet$Json$Response(params?: {

    /**
     * 1 &#x3D; Radii
     * 
     * 2 &#x3D; Linear
     * 
     * 3 &#x3D; Diameter
     * 
     * 4 &#x3D; SurfaceFinish
     * 
     * 5 &#x3D; Parallelism
     */
    type?: DimensionType;
  }): Observable<StrictHttpResponse<IsoStandardDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardGetAllByTypeGetPath, 'get');
    if (params) {
      rb.query('type', params.type, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardGetAllByTypeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetAllByTypeGet$Json(params?: {

    /**
     * 1 &#x3D; Radii
     * 
     * 2 &#x3D; Linear
     * 
     * 3 &#x3D; Diameter
     * 
     * 4 &#x3D; SurfaceFinish
     * 
     * 5 &#x3D; Parallelism
     */
    type?: DimensionType;
  }): Observable<IsoStandardDtoListBaseResponse> {

    return this.apiIsoStandardGetAllByTypeGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoListBaseResponse>) => r.body as IsoStandardDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardSearchAllGet
   */
  static readonly ApiIsoStandardSearchAllGetPath = '/api/IsoStandard/search-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardSearchAllGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardSearchAllGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<IsoStandardDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardSearchAllGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardSearchAllGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardSearchAllGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<IsoStandardDtoListBaseResponse> {

    return this.apiIsoStandardSearchAllGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoListBaseResponse>) => r.body as IsoStandardDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardSearchAllGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardSearchAllGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<IsoStandardDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardSearchAllGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardSearchAllGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardSearchAllGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<IsoStandardDtoListBaseResponse> {

    return this.apiIsoStandardSearchAllGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoListBaseResponse>) => r.body as IsoStandardDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardGetIsoStandardGet
   */
  static readonly ApiIsoStandardGetIsoStandardGetPath = '/api/IsoStandard/get-iso-standard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardGetIsoStandardGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetIsoStandardGet$Plain$Response(params?: {
    isoStandardId?: number;
  }): Observable<StrictHttpResponse<IsoStandardDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardGetIsoStandardGetPath, 'get');
    if (params) {
      rb.query('isoStandardId', params.isoStandardId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardGetIsoStandardGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetIsoStandardGet$Plain(params?: {
    isoStandardId?: number;
  }): Observable<IsoStandardDtoBaseResponse> {

    return this.apiIsoStandardGetIsoStandardGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoBaseResponse>) => r.body as IsoStandardDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardGetIsoStandardGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetIsoStandardGet$Json$Response(params?: {
    isoStandardId?: number;
  }): Observable<StrictHttpResponse<IsoStandardDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardGetIsoStandardGetPath, 'get');
    if (params) {
      rb.query('isoStandardId', params.isoStandardId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardGetIsoStandardGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardGetIsoStandardGet$Json(params?: {
    isoStandardId?: number;
  }): Observable<IsoStandardDtoBaseResponse> {

    return this.apiIsoStandardGetIsoStandardGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoBaseResponse>) => r.body as IsoStandardDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardAddIsoStandardPost
   */
  static readonly ApiIsoStandardAddIsoStandardPostPath = '/api/IsoStandard/add-iso-standard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardAddIsoStandardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddIsoStandardPost$Plain$Response(params?: {
    body?: IsoStandardDto
  }): Observable<StrictHttpResponse<IsoStandardDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardAddIsoStandardPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardAddIsoStandardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddIsoStandardPost$Plain(params?: {
    body?: IsoStandardDto
  }): Observable<IsoStandardDtoBaseResponse> {

    return this.apiIsoStandardAddIsoStandardPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoBaseResponse>) => r.body as IsoStandardDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardAddIsoStandardPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddIsoStandardPost$Json$Response(params?: {
    body?: IsoStandardDto
  }): Observable<StrictHttpResponse<IsoStandardDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardAddIsoStandardPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IsoStandardDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardAddIsoStandardPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddIsoStandardPost$Json(params?: {
    body?: IsoStandardDto
  }): Observable<IsoStandardDtoBaseResponse> {

    return this.apiIsoStandardAddIsoStandardPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<IsoStandardDtoBaseResponse>) => r.body as IsoStandardDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardUpdateIsoStandardPut
   */
  static readonly ApiIsoStandardUpdateIsoStandardPutPath = '/api/IsoStandard/update-iso-standard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardUpdateIsoStandardPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateIsoStandardPut$Plain$Response(params?: {
    body?: IsoStandardDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardUpdateIsoStandardPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardUpdateIsoStandardPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateIsoStandardPut$Plain(params?: {
    body?: IsoStandardDto
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardUpdateIsoStandardPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardUpdateIsoStandardPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateIsoStandardPut$Json$Response(params?: {
    body?: IsoStandardDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardUpdateIsoStandardPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardUpdateIsoStandardPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateIsoStandardPut$Json(params?: {
    body?: IsoStandardDto
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardUpdateIsoStandardPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardToggleArchiveIsoStandardPut
   */
  static readonly ApiIsoStandardToggleArchiveIsoStandardPutPath = '/api/IsoStandard/toggle-archive-iso-standard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardToggleArchiveIsoStandardPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardToggleArchiveIsoStandardPut$Plain$Response(params?: {
    isoStandardId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardToggleArchiveIsoStandardPutPath, 'put');
    if (params) {
      rb.query('isoStandardId', params.isoStandardId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardToggleArchiveIsoStandardPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardToggleArchiveIsoStandardPut$Plain(params?: {
    isoStandardId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardToggleArchiveIsoStandardPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardToggleArchiveIsoStandardPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardToggleArchiveIsoStandardPut$Json$Response(params?: {
    isoStandardId?: number;
    isArchive?: boolean;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardToggleArchiveIsoStandardPutPath, 'put');
    if (params) {
      rb.query('isoStandardId', params.isoStandardId, {});
      rb.query('isArchive', params.isArchive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardToggleArchiveIsoStandardPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardToggleArchiveIsoStandardPut$Json(params?: {
    isoStandardId?: number;
    isArchive?: boolean;
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardToggleArchiveIsoStandardPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardAddTolerancePost
   */
  static readonly ApiIsoStandardAddTolerancePostPath = '/api/IsoStandard/add-tolerance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardAddTolerancePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddTolerancePost$Plain$Response(params?: {
    body?: ToleranceDto
  }): Observable<StrictHttpResponse<ToleranceDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardAddTolerancePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ToleranceDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardAddTolerancePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddTolerancePost$Plain(params?: {
    body?: ToleranceDto
  }): Observable<ToleranceDtoBaseResponse> {

    return this.apiIsoStandardAddTolerancePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ToleranceDtoBaseResponse>) => r.body as ToleranceDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardAddTolerancePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddTolerancePost$Json$Response(params?: {
    body?: ToleranceDto
  }): Observable<StrictHttpResponse<ToleranceDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardAddTolerancePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ToleranceDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardAddTolerancePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddTolerancePost$Json(params?: {
    body?: ToleranceDto
  }): Observable<ToleranceDtoBaseResponse> {

    return this.apiIsoStandardAddTolerancePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ToleranceDtoBaseResponse>) => r.body as ToleranceDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardUpdateTolerancePut
   */
  static readonly ApiIsoStandardUpdateTolerancePutPath = '/api/IsoStandard/update-tolerance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardUpdateTolerancePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateTolerancePut$Plain$Response(params?: {
    body?: ToleranceDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardUpdateTolerancePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardUpdateTolerancePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateTolerancePut$Plain(params?: {
    body?: ToleranceDto
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardUpdateTolerancePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardUpdateTolerancePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateTolerancePut$Json$Response(params?: {
    body?: ToleranceDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardUpdateTolerancePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardUpdateTolerancePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateTolerancePut$Json(params?: {
    body?: ToleranceDto
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardUpdateTolerancePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardArchiveTolerancePut
   */
  static readonly ApiIsoStandardArchiveTolerancePutPath = '/api/IsoStandard/archive-tolerance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardArchiveTolerancePut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardArchiveTolerancePut$Plain$Response(params?: {
    toleranceId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardArchiveTolerancePutPath, 'put');
    if (params) {
      rb.query('toleranceId', params.toleranceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardArchiveTolerancePut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardArchiveTolerancePut$Plain(params?: {
    toleranceId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardArchiveTolerancePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardArchiveTolerancePut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardArchiveTolerancePut$Json$Response(params?: {
    toleranceId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardArchiveTolerancePutPath, 'put');
    if (params) {
      rb.query('toleranceId', params.toleranceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardArchiveTolerancePut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardArchiveTolerancePut$Json(params?: {
    toleranceId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardArchiveTolerancePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardAddToleranceClassPost
   */
  static readonly ApiIsoStandardAddToleranceClassPostPath = '/api/IsoStandard/add-tolerance-class';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardAddToleranceClassPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddToleranceClassPost$Plain$Response(params?: {
    body?: ToleranceClassDto
  }): Observable<StrictHttpResponse<ToleranceClassDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardAddToleranceClassPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ToleranceClassDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardAddToleranceClassPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddToleranceClassPost$Plain(params?: {
    body?: ToleranceClassDto
  }): Observable<ToleranceClassDtoBaseResponse> {

    return this.apiIsoStandardAddToleranceClassPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ToleranceClassDtoBaseResponse>) => r.body as ToleranceClassDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardAddToleranceClassPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddToleranceClassPost$Json$Response(params?: {
    body?: ToleranceClassDto
  }): Observable<StrictHttpResponse<ToleranceClassDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardAddToleranceClassPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ToleranceClassDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardAddToleranceClassPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardAddToleranceClassPost$Json(params?: {
    body?: ToleranceClassDto
  }): Observable<ToleranceClassDtoBaseResponse> {

    return this.apiIsoStandardAddToleranceClassPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ToleranceClassDtoBaseResponse>) => r.body as ToleranceClassDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardUpdateToleranceClassPut
   */
  static readonly ApiIsoStandardUpdateToleranceClassPutPath = '/api/IsoStandard/update-tolerance-class';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardUpdateToleranceClassPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateToleranceClassPut$Plain$Response(params?: {
    body?: ToleranceClassDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardUpdateToleranceClassPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardUpdateToleranceClassPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateToleranceClassPut$Plain(params?: {
    body?: ToleranceClassDto
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardUpdateToleranceClassPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardUpdateToleranceClassPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateToleranceClassPut$Json$Response(params?: {
    body?: ToleranceClassDto
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardUpdateToleranceClassPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardUpdateToleranceClassPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIsoStandardUpdateToleranceClassPut$Json(params?: {
    body?: ToleranceClassDto
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardUpdateToleranceClassPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiIsoStandardDeleteToleranceClassPut
   */
  static readonly ApiIsoStandardDeleteToleranceClassPutPath = '/api/IsoStandard/delete-tolerance-class';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardDeleteToleranceClassPut$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardDeleteToleranceClassPut$Plain$Response(params?: {
    toleranceClassId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardDeleteToleranceClassPutPath, 'put');
    if (params) {
      rb.query('toleranceClassId', params.toleranceClassId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardDeleteToleranceClassPut$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardDeleteToleranceClassPut$Plain(params?: {
    toleranceClassId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardDeleteToleranceClassPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIsoStandardDeleteToleranceClassPut$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardDeleteToleranceClassPut$Json$Response(params?: {
    toleranceClassId?: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, IsoStandardService.ApiIsoStandardDeleteToleranceClassPutPath, 'put');
    if (params) {
      rb.query('toleranceClassId', params.toleranceClassId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiIsoStandardDeleteToleranceClassPut$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIsoStandardDeleteToleranceClassPut$Json(params?: {
    toleranceClassId?: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiIsoStandardDeleteToleranceClassPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

}
